export let AuthConfiguration = {

    /*
      - this object represents the mapping between the urls of the modules and the pages and their respective names in the backend
      - For public pages and modules, they MUST be mapped to the string 'public'
     */

    modules: {
        'reportlog': 'reportlog',
        'devices': 'devices',
        'users': 'public',
        'administration': 'administration',
        'analytics': 'analytics',
        'operations': 'operations',
        'resources': 'resources',
        'tracking': 'tracking',
        'subscriberusers': 'subscriberusers',
        'adminlanding': 'adminlanding',
        'maintenance': 'maintenance',
        'technicalsupport':'technicalsupport'
    },

    pages: {
        // livetrack
        'live': 'live_tracking',
        'monitor': 'live_monitoring',
        'history': 'history',
        'speedreport': 'public',
        'temperaturereport': 'public',
        // resources
        'transporterlist': 'vehicles_management',
        'transporterdetails': 'vehicles_edit',
        'transporterdetailsview': 'vehicles_view',
        'poi': 'pois_management',
        'userlist': 'users_management',
        'userdetails': 'users_edit',
        'geofence': 'geofences_management',
        'branches': 'branches',

        // reporting
        'detailed': 'detailed_report',
        'aggregated': 'aggregated_reprort',
        // 'overalldashboard': 'overall_dashboard',
        // 'outliersdashboard': 'outliers_dashboard',
        // 'violationdashboard': 'violation_dashboard',
        'dashboard': 'dashboard',
        'staticreports': 'static_reports',
        'operational': 'operational_reports',

        // operations
        'branch-allocation': 'branch-allocation',
        'resource-allocation': 'resource-allocation',
        'workorder':"workorder_list",
        'workorder-reallocation': 'workorder_reallocation',
        'normaorderslist': "order_list",
        'orderdetails': "public",
        'ordersrawdatareport': 'public',
        'drivercapacitydashboard': "public",
        'orderreceiving': 'order_receiving',
        'orderreturnsconfirmation':'public',
        // administration
        'subscriberlist': 'subscribers_management',
        'settings': 'subscriber_settings',
        'permittedbranches': 'permitted_branches_management',
        'notificationsettings-wizard': 'notificationsettings_wizard',
        'subscriber': 'subscriber_edit',
        'organization': 'organization_chart',
        'devicelist': 'devices_management',
        'roles': 'roles-management',
        "workorderwizard": 'manual_workorder',
        "notificationssettings": 'public',
        "changepassword": 'public',
        'planning': "public",

        //technicalsupport
        'changeorderstatus':'changeorderstatus',

        // report and log
        'poilog': 'poi_log',
        'gpsdisconnected': 'public',
        'geofencelog': 'geofence_log',
        'packetslog': 'packet_log',
        'vehicleslog': 'vehicle_log',
        'stafflog': 'staff_log',
        'vehiclessummary': 'vehicle_summary',
        'firstsignalreport': 'first_signal',
        'subscribersummaryreport': 'subscriber_summary',
        'usersummaryreport': 'user_summary',
        'smslog': 'public',

        // Device List
        'list': 'device_list',
        'log': 'device_log',
        'adddevice': 'public',
        
        //subscriberusers
        'unlockusers': 'unlock_users',

        //adminlanding
        'welcome': 'admin_landing',
        // maintenance
        'pmlist': 'pm_list',
        "repairslist": 'repairs_list',
        'addnewpmp': 'pmp',
        'rfrdetails': 'rfr_details',
        'addnewmwo': 'maintenance_workorder',
       
    },

    paths: {
        pageNotFoundUrl: '/pagenotfound'
    }
};




// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/configurations/auth.config.ts